import React from 'react';
import { FaUserCircle } from 'react-icons/fa'; // Example icon from react-icons
import { useSelector } from 'react-redux';
import TruckImage from '../../assets/image/Truck.png';
import BicycleImage from '../../assets/image/Bicycle.png';
import Car from '../../assets/image/Mini.png';
const NotificationSection = () => {
  const { adminUnReadNotification } = useSelector((state) => state.auth);
  const getVehicleIcon = (vehicleType) => {
    if (!vehicleType) {
      console.warn('vehicleType is undefined or null');
      return null;
    }

    switch (vehicleType.toLowerCase()) {
      case 'car':
        return (
          <img
            src={Car}
            alt='Car'
            className='w-8 h-auto'
          />
        ); // Replace with car image
      case 'bike':
        return (
          <img
            src={BicycleImage}
            alt='Bicycle'
            className='w-8 h-auto'
          />
        );
      case 'commercial vehicle':
        return (
          <img
            src={TruckImage}
            alt='Commercial Vehicle'
            className='w-8 h-auto'
          />
        );

      default:
        return null;
    }
  };
  return (
    <div className='bg-white p-4'>
      <h2 className='text-lg font-semibold mb-4'>Notification</h2>

      {/* Table Header */}
      <div className='grid grid-cols-4 px-0  gap-x-20 whitespace-nowrap font-linear text-gray-700 mb-4'>
        <div className='text-sm'>Name</div>
        <div className='text-sm ml-[-30px]'>Landing Time</div>{' '}
        {/* Adjusted left margin */}
        <div className='text-sm ml-[-29px]'>Vehicle Type</div>{' '}
        {/* Adjusted left margin */}
        <div className='text-sm ml-[-20px]'>Status</div>
      </div>

      {/* Notification Items */}
      <ul className='space-y-4 max-h-[140px] overflow-y-auto'>
        {adminUnReadNotification.length > 0 ? (
          <>
            {adminUnReadNotification?.map((n, index) => (
              <li
                key={index}
                className='flex justify-between items-center px-0 py-0 border-b'
              >
                {/* User Name Column */}
                <div className='flex items-center text-sm w-1/4'>
                  <span>{n.userDetails[0]?.name}</span>
                </div>

                {/* Notification Date Column */}
                <span className='text-sm w-1/4'>
                  {(() => {
                    const notificationAt = new Date(n.notificationAt);
                    notificationAt.setMonth(notificationAt.getMonth() - 1);
                    return notificationAt.toISOString().split('T')[0];
                  })()}
                </span>

                {/* Vehicle Type Icon Column */}
                <span className='text-sm w-1/4'>
                  {getVehicleIcon(n.requestDetails[0]?.vehicleType)}
                </span>

                {/* Notification Type Column */}

                <small
                  className='rounded text-white px-1 w-1/5 text-[10px]'
                  style={{ backgroundColor: '#64CFF6' }}
                >
                  {n.notificationType}
                </small>
              </li>
            ))}
          </>
        ) : (
          <small className='text-center'>No new notification exist</small>
        )}
      </ul>
    </div>
  );
};

export default NotificationSection;
